<template>
  <div 
    @click="handleClick"
    class="relative bg-white border border-gray-200 rounded-lg overflow-hidden transition-all duration-200 cursor-pointer hover:border-gray-400"
    :class="{ 'border-[#E9041D] bg-red-50': isSelected }"
  >
    <div class="p-3 flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <div 
          class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors"
          :class="isSelected ? 'border-[#E9041D] bg-[#E9041D]' : 'border-gray-300'"
        >
          <svg 
            v-if="isSelected"
            xmlns="http://www.w3.org/2000/svg" 
            class="h-3 w-3 text-white" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div>
          <h3 class="font-medium text-gray-800 text-sm">{{ location.name }}</h3>
          <p class="text-xs text-gray-500">{{ getLocationTypeName(location.location_type) }}</p>
        </div>
      </div>
      <div class="text-right">
        <div v-if="location.is_locked" class="text-xs text-red-500">Gesperrt</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface LocationType {
  id: number
  name: string
}

interface Location {
  id: number
  name: string
  location_type: LocationType
  is_locked: boolean
}

const props = defineProps<{
  location: Location
  isSelected: boolean
}>()

const emit = defineEmits<{
  select: [id: number]
}>()

const handleClick = () => {
  emit('select', props.location.id)
}

const getLocationTypeName = (locationType: LocationType) => {
  const typeNames: Record<string, string> = {
    'drehplatz': 'Drehplatz',
    'servicecenter': 'Servicecenter',
    'parkplatz': 'Parkplatz'
  }
  return typeNames[locationType.name.toLowerCase()] || locationType.name
}
</script>